import React, { useState } from 'react';
import styles from './index.modules.less';
import { SearchBar } from 'antd-mobile';
import EmptyTips from 'pubBiz/EmptyTips';

export default function CommonPickerModal({
  list,
  labelKey = 'label',
  valueKey = 'value',
  visible,
  onVisibleChange,
  onSelect,
  searchPlaceholder = '请输入关键字',
  height = '80%'
}) {
  const [keyword, setKeyword] = useState('');
  const handleClose = () => {
    setKeyword('');
    onVisibleChange && onVisibleChange(false);
  };
  if (!visible) {
    return false;
  }

  const showList = list.filter((item) => item[labelKey].includes(keyword.trim()));
  let emptyText = '';
  if (!list.length) {
    emptyText = '暂无可用支行';
  }
  if (keyword.trim() && showList.length === 0) {
    emptyText = '无匹配支行';
  }
  return (
    <div className={styles.container}>
      <div className={styles.mask} onClick={handleClose}></div>
      <div
        className={styles.wrap}
        style={{
          height
        }}>
        <div className={styles.header}>
          <SearchBar
            placeholder={searchPlaceholder}
            maxLength={100}
            value={keyword}
            onChange={(v) => setKeyword(v)}
            onCancel={handleClose}
            cancelText={'关闭'}
            showCancelButton></SearchBar>
        </div>
        <div className={styles.list}>
          {showList.map((item) => {
            return (
              <div
                key={item[valueKey]}
                className={styles.item}
                onClick={(e) => {
                  e.stopPropagation();
                  return onSelect && onSelect(item);
                }}>
                {item[labelKey]}
              </div>
            );
          })}
          {emptyText ? (
            <EmptyTips thumb={`${CDN_BASE}/assets/imgs/default/no_message.png`} title={emptyText} />
          ) : null}
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pubBiz/CommonPickerModal/index.js